import * as yup from 'yup';

export const pelabuhanBongkarValidation =  yup.object().shape({
    id_lokasi: yup.string().required('Harus diisi'),
    kd_kantor: yup.string().required('Harus diisi'),
    nm_lokasi: yup.string().required('Harus diisi'),
    nm_kantor_pendek: yup.string().required('Harus diisi'),
    latitude: yup.string().required('Harus diisi'),
    longitude: yup.string().required('Harus diisi'),
}).required()